var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconOpeningLeft = function SvgIconOpeningLeft(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.055,21.059a1,1,0,0,0,.613,1.273.98.98,0,0,0,.33.057,1,1,0,0,0,.943-.67A18.748,18.748,0,0,0,32,15.5a1,1,0,0,0-2,0A16.8,16.8,0,0,1,29.055,21.059ZM22.5,26a1,1,0,0,1,1,1v1.865a18.275,18.275,0,0,0,3.021-3.1,1,1,0,1,1,1.591,1.209A20.112,20.112,0,0,1,25.244,30H26.5a1,1,0,0,1,0,2h-4a1,1,0,0,1-1-1V27A1,1,0,0,1,22.5,26ZM8,9V26.422a1,1,0,0,0,.547.891l9,4.579A1,1,0,0,0,19,31V13.977a1,1,0,0,0-.516-.875L12.875,10H21.5V22a1,1,0,0,0,2,0V9a1,1,0,0,0-1-1H9.5a1.927,1.927,0,0,0-1.008.139A1,1,0,0,0,8,9Zm2,1.7,7,3.871v14.8l-7-3.56Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconOpeningLeft, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-opening-left.f5bdfdff.svg";
export { ForwardRef as ReactComponent };